import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, NgZone, OnDestroy, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { TreatmentPlanningService } from './treatment-planning.service';
import { Globals } from '../../globals';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ToothPickerComponent } from '../tdo-shared/tooth-picker/tooth-picker.component';
import { CaseFormsService } from '../case-forms/case-forms.service';
import { ARService } from '../ar/ar.service';
import { TreatmentPlanningProcedurePseudoModel } from './models/treatment-planning-procedure-pseudo.model';
import { DoctorDataModel } from '../../models/doctors/doctor-data.model';
import { PrintTreatmentPlanningModel, TreatmentPlanningDataModel } from './models/treatment-planning-data.model';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatTab, MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { TreatmentTabModel } from './models/treatment-tab.model';
import { PatientDataModel } from '../../models/patient/patient-data.model';
import { CommMethodEnum } from '../../models/enum/comm-method.enum';
import { ContactCommsDataModel } from '../../models/person/contact-comms-data.model';
import { FormsTabModel } from './models/forms-tab.model';
import { FeeStructureDataModel } from '../../models/patient/fee-structure-data.model';
import { ToothService } from '../../services/tooth.service';
import { ToothUiManagerModel } from '../tdo-shared/tooth-picker/tooth-ui-manager/tooth-ui-manager.model';
import { FormsDialogComponent } from '../../dialog/forms-dialog/forms-dialog.component';
import { FeeCoverageCalcTypeEnum } from '../../models/enum/fee-coverage-calc-type.enum';
import { InsuranceService } from '../insurance/insurance.service';
import { FeeItemCategoryIdEnum } from '../../models/enum/fee-item-category-id.enum';
import { ToothConfigurationModel } from '../../models/teeth/tooth-configuration.model';
import { ToothPickerConfigModel } from '../tdo-shared/tooth-picker/tooth-picker-config.model';
import { PatientInsuranceDataModel } from '../../models/patient/patient-insurance-data.model';
import { NotesService } from '../../services/notes.service';
import { TdoNoteQueryModel } from '../../main-interface/controls/tdo-notes/models/tdo-note-query.model';
import { TdoTableSelectionEvent } from '../../tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import { TdoTableV2Component } from '../../tdo-controls/common/tdo-table-v2/tdo-table-v2.component';
import { DialogService } from '../../services/dialog.service';
import { MessagingService } from '../../services/messaging.service';
import { MessagingConstants } from '../../models/MessagingConstants';
import { TdoDropdownChange } from '../../tdo-controls/common/tdo-dropdown-v2/models/tdo-dropdown-change';
import { EndoMultiToothExamDataModel } from '../../models/forms/custom/mti/endo-multi-tooth-exam-data.model';
import { MtiService } from '../../services/form/mti.service';
import { EnumValidValueItemModel } from '../../models/enum/enum-valid-value-item.model';
import { EndoMultiToothExamTeethInExamDataModel } from '../../models/forms/custom/mti/endo-multi-tooth-exam-teeth-in-exam-data.model';
import { MtiTeethDialogComponent } from '../forms/custom/mti/dialog/mti-teeth-dialog/mti-teeth-dialog.component';
import { CreatePatientCaseModel } from '../../models/caseProcedures/create-patient-case.model';
import { LocalStorageService } from '../../services/local-storage.service';
import { AzureBlobStorageService } from '../../services/blob/azure-blob-storage.service';
import { BlobModel } from '../../models/blob/blob.model';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { TdoSimpleNoteComponent } from "../../tdo-controls/common/tdo-simple-note/tdo-simple-note.component";
import { NoteTypeEnum } from "../../models/enum/note-type.enum";
import { NoteCategoryEnum } from "../../models/enum/note-category.enum";
import { UiService } from 'src/app/services/ui.service';
import { CfgARFeeDiscountModel } from 'src/app/models/accountsReceivable/cfg-ar-fee-discount.model';
import { EnumFeeDiscountCalcTypeEnum } from 'src/app/models/enum/enum-fee-discount-calc-type.enum';
import { DoctorsService } from 'src/app/services/doctors.service';
import { TdoClientConfigurationModel } from 'src/app/models/clients/tdo-client-configuration.model';
import { CaseAddProcedureComponent } from '../case-forms/case-add-procedure/case-add-procedure.component';
import { Constants } from 'src/app/constants';
import { DataPatientCaseWorkItemModel } from 'src/app/models/accountsReceivable/data-patient-case-work-item.model';
import { TDOPrintService } from 'src/app/services/print/tdoprint.service';
import { ReportIDEnum } from 'src/app/models/enum/report-ID-enum';
import { ConversionUtilities } from 'src/app/utilities/conversion.utilities';
import { FileManagerService } from '../file-manager/file-manager.service';
import SignaturePad from 'signature_pad';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
@Component({
  standalone: false,
  selector: 'app-treatment-planning',
  templateUrl: './treatment-planning.component.html',
  styleUrls: ['./treatment-planning.component.scss']
})
export class TreatmentPlanningComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('proceduresTable') proceduresTable: TdoTableV2Component;
  // @ViewChild(SignaturePad) signaturePad: SignaturePad;
  @ViewChild('signatureContainer') signatureContainer: ElementRef<HTMLCanvasElement>;
  @ViewChild('padContainer') padContainer: ElementRef<HTMLDivElement>;
  signaturePad: SignaturePad;
  @ViewChild(MatTabGroup, { read: MatTabGroup }) tabGroups;
  @ViewChild('simpleNote') simpleNote: TdoSimpleNoteComponent;
  @ViewChild('padContainer') formElement: ElementRef;

  @ViewChild('tableContainer') tableContainer: HTMLDivElement;

  @ViewChildren(MatTab, { read: MatTab }) tabs;

  @Input() caseWorkItemFormsId: string;
  @Input() caseToothId: string;

  private resizeSignatureInterval: any;

  readonly NoteCategoryEnum = NoteCategoryEnum;
  readonly NoteTypeEnum = NoteTypeEnum;

  tabGroup: MatTabGroup;
  // public tabNodes: QueryList<MatTab>;
  // public closedTabs = [];
  treatmentTabs: Array<TreatmentTabModel> = new Array<TreatmentTabModel>();
  formTabs: Array<FormsTabModel> = new Array<FormsTabModel>();

  /**
   * Treatment plans can have a parent treatment plan. Treatment plans can have options, that range in prices.
   * When creating a new option, a new treatment plan will be created, but it's ParentTreatmentPlanningID will not be null.
   * This is how we differentiate between the parent and the children plans.
   */
  listOfParentTreatmentPlans: TreatmentPlanningDataModel[] = [];
  listOfParentTreatmentPlansSelectedIndex: number;
  selectedParentTreatmentPlan: TreatmentPlanningDataModel;

  currentTreatmentPlans: TreatmentPlanningDataModel[] = [];
  selectedTreatmentPlan: TreatmentPlanningDataModel;
  optionPlanSelected: TreatmentPlanningDataModel;
  optionPlanSelectedIndex: number = 0;
  selectedProcedures: Array<TreatmentPlanningProcedurePseudoModel> = new Array<TreatmentPlanningProcedurePseudoModel>();
  isAnythingSelected: boolean = false;

  doctorList: DoctorDataModel[];
  codesList: FeeStructureDataModel[];
  teeth: ToothConfigurationModel[];



  popupProcedureListVisible = false;
  isLoading = false;
  isApproving = false;
  isUserInput: boolean = false;
  now: Date;

  codeSearchSubscription: any;
  listOfProceduresByCode: any;

  tabPanelTreatmentPlanSelectedIndex: number = 0;
  patientEmailAddress = 'abc@xyz.com';
  currentOptionItem: any;

  uiProcedureListOptions = ['Select', 'Frequently Used'];
  saveSubscription: any;

  timeoutInstanceId: string;

  patient: PatientDataModel;
  preferredSmsComm: ContactCommsDataModel;
  preferredEmailComm: ContactCommsDataModel;
  selectedCommTabIndex: number;
  caseWorkItemEventDoc: DataPatientCaseWorkItemModel;

  insuranceModels: PatientInsuranceDataModel[];
  currentDoctorId: string;

  showPad: boolean = false;
  hasSignaturePad: boolean = false;
  signaturePadOptions: object = {
    minWidth: 2,
    canvasHeight: 66,
    canvasWidth: 700
  };
  mtiExams: EndoMultiToothExamDataModel[] = [];
  mtiExam: EndoMultiToothExamDataModel;
  signatureBase64: SafeUrl = null;
  sendToPreferredEmail: boolean;
  sendToPreferredSMS: boolean;
  feeDiscount: CfgARFeeDiscountModel[] = [];
  feeDiscounts: CfgARFeeDiscountModel[] = [];
  showDiagnosis: boolean = false;
  cfgTDOClient: TdoClientConfigurationModel;
  deductibleLeft: number;
  ARNonEstimatingDeductibleLeft: number;
  AREstimateDeductibleLeftOther: number;
  AREstimateDeductibleLeftPreventative: number;
  AREstimateDeductibleLeftStandard: number;
  insuranceBenefitsLeft: number;
  searchCode: string;
  selectedCodeInput: HTMLInputElement;
  selectedTreatmentPlanReadOnly: boolean = false;
  signatureURL: string;
  signatureDrawn: boolean;
  

  constructor(
    private readonly treatmentPlanningService: TreatmentPlanningService,
    public globals: Globals,
    private readonly caseService: CaseFormsService,
    private readonly dialog: MatDialog,
    private readonly arService: ARService,
    private readonly toothService: ToothService,
    private readonly insuranceService: InsuranceService,
    private readonly notesService: NotesService,
    private readonly messagingService: MessagingService,
    private readonly dialogService: DialogService,
    private readonly mtiService: MtiService,
    private readonly localStorageService: LocalStorageService,
    private readonly azureService: AzureBlobStorageService,
    private readonly sanitizer: DomSanitizer,
    private readonly doctorService: DoctorsService,
    private readonly fileManagerService: FileManagerService,
    private readonly printService: TDOPrintService,
    private readonly uiService: UiService,
    private readonly cdr: ChangeDetectorRef,
    private readonly ngZone: NgZone
  ) {
    this.patient = this.globals.ThePatient;



    if (!this.toothService.allTeeth || this.toothService.allTeeth.length === 0) {
      // TODO: Things like this will need to be updated once we have a way to check settings like geoloc.
      this.toothService.getAllTeeth(ToothService.enumUnitedStatesToothGrouping).subscribe((teeth) => {
        this.teeth = teeth;
      });
    } else {
      this.teeth = this.toothService.allTeeth;
    }

    if (!this.localStorageService.practicingDoctorId && !this.localStorageService.loggedInDoctorId) {
      this.dialogService.openConfirmDialog('You are not signed in as a doctor and no doctor was selected from the case view.');
    } else {
      if (this.localStorageService.practicingDoctorId) {
        this.currentDoctorId = this.localStorageService.practicingDoctorId;
      } else {
        this.currentDoctorId = this.localStorageService.loggedInDoctorId;
      }
    }

  }
  ngAfterViewInit(): void {
    this.resizeSignature();
  }

  ngOnDestroy(): void {
    if (this.resizeSignatureInterval) {
      clearInterval(this.resizeSignatureInterval);
    }
  }
  onToggleDiagnosisClick() {
    this.showDiagnosis = !this.showDiagnosis;
  }

  onProcedureRowClick(procedure: TreatmentPlanningProcedurePseudoModel) {
    // Use this to change the form on the right per procedure.

    this.changeNotesQuery('dataTreatmentPlanningProcedures', procedure.TreatmentPlanningProcedureID);
  }

  ngOnInit() {
    try {
      this.isLoading = true;
      this.refreshView();

      // get tdocid insurance related info
      this.insuranceService.getTDOClient().subscribe(response => {
        // set results
        this.cfgTDOClient = response[0];
        this.refreshView();
      });

      this.insuranceService.getPatientInsuranceByPatientId(this.globals.currentPatientId).subscribe((res) => {
        this.insuranceModels = res;
        this.refreshView();
      });
      this.getDiscounts();
      this.determinePreferredCommunication();
      this.mtiService.getExams(this.globals.currentPatientId).subscribe((examsRes) => {
        this.mtiExams = examsRes;
        this.refreshView();
        if(this.caseWorkItemFormsId){
          this.treatmentPlanningService.getTreatmentPlanByCaseWorkItemFormsId(this.caseWorkItemFormsId).subscribe((data) => {
            if(data){
              this.loadTreatmentPlanList(data.TreatmentPlanningID);
            }
            else{
              this.loadTreatmentPlanList('');
            }
            this.refreshView();
          });
        }
        else{
        this.loadTreatmentPlanList('first');
        this.refreshView();
      }
      });

      this.messagingService.sendComponentMessage(MessagingConstants.NOTES_MINIMIZE, {});

      this.messagingService.componentMessageCall.subscribe((response) => {
        if (response.event === MessagingConstants.PATIENT_LOADED) {
          this.currentTreatmentPlans = [];
          this.selectedParentTreatmentPlan = null;
          this.isLoading = true;
          this.refreshView();

          this.insuranceService.getPatientInsuranceByPatientId(this.globals.currentPatientId).subscribe((res) => {
            this.insuranceModels = res;
            this.refreshView();
          });
          this.determinePreferredCommunication();
          this.loadTreatmentPlanList('');
        }
      });
    } catch (err) {
      this.isLoading = false;
      this.refreshView();
      this.uiService.displayMessage('Error', 'Error initializing information');
    }
  }

  // Load Data
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  loadTreatmentPlanList(toSelect: string) {
    this.isLoading = true;
    this.refreshView();
    this.treatmentPlanningService.getTreatmentPlanList(this.globals.currentPatientId).subscribe((data) => {
      //console.log('loadTreatmentPlanList getTreatmentPlanList:', data);
      this.listOfParentTreatmentPlans = data;
      // select
      if (toSelect !== '') {
        if (toSelect === 'first')
          this.selectedParentTreatmentPlan = this.listOfParentTreatmentPlans.at(0);
        else
          this.selectedParentTreatmentPlan = this.listOfParentTreatmentPlans.find(p => p.TreatmentPlanningID === toSelect);
        this.setParentTreatmentPlan(this.selectedParentTreatmentPlan);
      }
      else {
        const tmp = this.listOfParentTreatmentPlans.find(p => p.CaseWorkItemFormsId === this.caseWorkItemFormsId);
        if (tmp) {
          this.selectedParentTreatmentPlan = tmp;
          this.listOfParentTreatmentPlansSelectedIndex = this.listOfParentTreatmentPlans.findIndex(p => p === this.selectedParentTreatmentPlan);
          this.setParentTreatmentPlan(this.selectedParentTreatmentPlan);
        }
        else{
          this.isLoading = false;
          this.refreshView();
        }
      }
      this.refreshView();
    }, err => {
      console.log(err);
      this.uiService.displayMessage('Error', 'Error obtaining Plan list');
      this.isLoading = false;
      this.refreshView();
    });
  }
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  // Events
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  onSelectedTreatmentPlanChange(event: TdoDropdownChange) {
    console.log('onSelectedTreatmentPlanChange:', event);
    if (event.value && this.selectedParentTreatmentPlan?.TreatmentPlanningID != event.value.TreatmentPlanningID) {
      this.signatureURL = null;
      //this.selectedParentTreatmentPlan = event.value;
      this.setParentTreatmentPlan(event.value);
      //this.resizeSignature();
    }
  }

  async onSelectedTreatmentPlanDoctor(event) {
    this.selectedTreatmentPlan.DoctorID = event.DoctorID;
    this.isLoading = true;
    await this.treatmentPlanningService.saveTreatmentPlan(this.selectedTreatmentPlan).toPromise();
    this.isLoading = false;
  }

  initSignaturePad() {
    this.signaturePad = new SignaturePad(this.signatureContainer.nativeElement);
    this.signaturePad.addEventListener("beginStroke", () => {
      this.onSignatureDrawStart();
    });
    this.signaturePad.addEventListener("endStroke", () => {
      //this.onSignatureDrawComplete();
    });
  }

  clearSignaturePad() {
    this.signatureDrawn = false;
    this.signaturePad.clear();
  }

  onSignatureDrawComplete() {
    // will be notified of szimek/signature_pad's onEnd event
    if (!this.signatureDrawn && this.signaturePad.isEmpty())
      return;
    this.signatureDrawn = true;
    const drawData = this.signaturePad.toDataURL();
    fetch(drawData)
      .then(res => res.blob())
      .then((tmp) => {
        const blobModel = new BlobModel();
        blobModel.name = this.selectedTreatmentPlan.TreatmentPlanningID + '.jpg';
        blobModel.content = tmp;
        blobModel.patientId = this.globals.currentPatientId;
        this.azureService.uploadBlobs([blobModel], (isSuccess) => {
        });
      });
  }

  onSignatureDrawStart() { 
    console.log("onSignatureDraw");
    this.signatureDrawn = true;
  }
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  // Add / Remove content
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  setParentTreatmentPlan(model: TreatmentPlanningDataModel) {
    if (!model) {
      console.log('setParentTreatmentPlan: model is null');
      this.isLoading = false;
      this.refreshView();
      return;
    }
    this.isLoading = true;
    this.selectedParentTreatmentPlan = model;
    this.listOfParentTreatmentPlansSelectedIndex = this.listOfParentTreatmentPlans.findIndex(p => p === this.selectedParentTreatmentPlan);
    this.refreshView();

    if (this.selectedParentTreatmentPlan.MTEID) {
      this.mtiExam = this.mtiExams.find(p => p.MTEID === this.selectedParentTreatmentPlan.MTEID);
    }

    this.treatmentPlanningService.getTreatmentPlan(this.selectedParentTreatmentPlan.TreatmentPlanningID).subscribe((plans) => {
      this.treatmentTabs = new Array<TreatmentTabModel>();
      // Keep [(selectedIndex)] in range when option tab count changes (stale index caused NG0100: 19 -> -1)
      this.tabPanelTreatmentPlanSelectedIndex = 0;
      this.currentTreatmentPlans = plans;
      this.setupPlanTeeth();

      if (this.currentTreatmentPlans && this.currentTreatmentPlans.length > 0) {
        this.selectedTreatmentPlan = this.currentTreatmentPlans[0];
        //console.log('setparent selectedTreatmentPlan:', JSON.parse(JSON.stringify(this.selectedTreatmentPlan)));
        
        // Sort procedures by creation timestamp to maintain FIFO order
        if (this.selectedTreatmentPlan.Procedures && this.selectedTreatmentPlan.Procedures.length > 0) {
          // Precompute timestamps to avoid repeated Date parsing during sort
          const proceduresWithTimestamp = this.selectedTreatmentPlan.Procedures.map((p, index) => {
            let timestamp = 0; // Default fallback timestamp
            
            if (p.xauditCreatedOn) {
              const parsedDate = new Date(p.xauditCreatedOn);
              if (!isNaN(parsedDate.getTime())) {
                timestamp = parsedDate.getTime();
              } else {
                // Invalid date: use index as fallback to maintain some order
                timestamp = index;
              }
            } else {
              // Null/undefined date: use index as fallback
              timestamp = index;
            }
            
            return {
              procedure: p,
              timestamp: timestamp
            };
          });
          
          proceduresWithTimestamp.sort((a, b) => a.timestamp - b.timestamp);
          this.selectedTreatmentPlan.Procedures = proceduresWithTimestamp.map(p => p.procedure);
        }
        
        this.setOptionPlanSelected(this.currentTreatmentPlans[0]);
        this.calculateCurrentTreatmentPlanCost(false);
        this.initSignaturePad();
        this.resizeSignature();

      } else {
        this.isLoading = false;
        this.changeNotesQuery();
      }

      for (const plan of this.currentTreatmentPlans) {
        this.addTab(plan);
      }
      this.isLoading = false;
      this.refreshView();
    }, err => {
      this.isLoading = false;
      this.refreshView();
      this.uiService.displayMessage('Error', 'Something went wrong obtaining the treatment plan.');
    });
  }

  private refreshView() {
    this.ngZone.run(() => {
      this.safeDetectChanges();
    });
  }

  getSignature() {
    console.log('getSignature: call getSignature: ');
    if (this.signaturePad)
      this.signaturePad.clear();
    this.signatureURL = null;
    if (this.optionPlanSelected?.TreatmentPlanningID) {
      // this.signatureBase64 = this.sanitizer.bypassSecurityTrustUrl(this.fileManagerService.getDocumentImageUrl(this.globals.currentPatientId, this.optionPlanSelected.TreatmentPlanningID + '.jpg'));
      // this.resizeSignature();
      this.isLoading = true;
      const signatureFilename = this.fileManagerService.getDocumentImageUrl(this.globals.currentPatientId, this.optionPlanSelected.TreatmentPlanningID + '.jpg');
      console.log('getSignature: downloadBlob signatureFilename: ', signatureFilename);
      this.azureService.downloadBlob(signatureFilename, (res) => {
        if (res) {
          this.signatureDrawn = true;
          this.signatureURL = URL.createObjectURL(res);
          if (this.optionPlanSelected?.enumTreatmentPlanStatusID.toLowerCase()!='00000a32-1000-0000-0000-000000000004'){
            //this.resizeSignature();
            this.signaturePad.fromDataURL(this.signatureURL);
          }
          else
            this.signatureBase64 = this.sanitizer.bypassSecurityTrustUrl(this.signatureURL);
        } else {
          this.signatureBase64 = null;
        }
        this.resizeSignature();
        this.isLoading = false;
      });
    }
  }

  setupPlanTeeth() {
    for (const plan of this.currentTreatmentPlans) {
      for (const proc of plan.Procedures) {
        proc.toothModel = this.teeth.find(p => p.ToothId === proc.ToothID);
      }
    }
  }

  addTab(dataModel: TreatmentPlanningDataModel) {

    const tabObj = new TreatmentTabModel();
    tabObj.name = dataModel.Description;
    tabObj.inNameEditingMode = false;
    tabObj.tabType = this.treatmentTabs.length;
    dataModel.isApprovalPending = this.isOptionApprovalPending(dataModel);
    dataModel.isApproved = this.isOptionApproved(dataModel);
    tabObj.dataModel = dataModel;
    this.treatmentTabs.push(tabObj);
  }


  onEditTabClick(tab: TreatmentTabModel) {

    if (tab.inNameEditingMode) {
      this.saveTabNameDescription(tab);
    }

    tab.inNameEditingMode = !tab.inNameEditingMode
  }


  onCloseTabClick(tab: TreatmentTabModel) {
    event.stopPropagation();
    this.dialogService.openConfirmDialog(`Are you sure you want to delete: <b>${tab.dataModel.Description}</b>?`).subscribe((isConfirmed) => {
      if (isConfirmed) {
        this.deleteTreatmentPlan(tab.dataModel);
        const idx = this.treatmentTabs.findIndex(p => p === tab);
        this.treatmentTabs.splice(idx, 1);
      }
    });
  }

  onCodeInput(event) {
  }

  onOptionTabChange(event: MatTabChangeEvent) {
    console.log('onOptionTabChange:', event);
    this.signatureURL = null;
    this.selectedTreatmentPlan = this.currentTreatmentPlans[this.tabPanelTreatmentPlanSelectedIndex];
    this.setOptionPlanSelected(this.selectedTreatmentPlan);
  }

  changeNotesQuery(parentName: string = 'dataTreatmentPlanning', objectId: string = this.selectedTreatmentPlan?.TreatmentPlanningID) {
    const noteQueryModel = new TdoNoteQueryModel();
    noteQueryModel.parentObjectName = parentName;
    noteQueryModel.objectId = objectId;
    noteQueryModel.patientId = this.globals.currentPatientId;
    noteQueryModel.categoryEnumId = NoteCategoryEnum.TreatmentPlanning;
    noteQueryModel.typeEnumId = NoteTypeEnum.Patient;

    this.notesService.changeNoteQuery(noteQueryModel);
  }

  onSelectAllCheckbox(event: MatCheckboxChange) {
    if (event.checked) {
      this.selectedProcedures = new Array<TreatmentPlanningProcedurePseudoModel>();
      for (const mod of this.selectedTreatmentPlan.Procedures) {
        mod.isSelected = true;
        this.selectedProcedures.push(mod);
      }
      this.isAnythingSelected = true;
    } else {
      this.deselectAllSelectedProcedures();
    }
  }

  onItemCheckBox(event: MatCheckboxChange, procedure: TreatmentPlanningProcedurePseudoModel) {
    if (!procedure.isSelected) {
      procedure.isSelected = true;
      this.selectedProcedures.push(procedure);
    }
    else {
      const idx = this.selectedProcedures.findIndex(p => p === procedure);
      if (idx > -1) {
        procedure.isSelected = false;
        this.selectedProcedures.splice(idx, 1);
      }
    }
    procedure.isSelected = event.checked;
    this.isAnythingSelected = this.selectedProcedures.length > 0;
  }

  deselectAllSelectedProcedures() {
    for (const mod of this.selectedTreatmentPlan.Procedures) {
      mod.isSelected = false;
    }

    this.isAnythingSelected = false;
    this.selectedProcedures = new Array<TreatmentPlanningProcedurePseudoModel>();
  }

  calculateProcedureCosts(procedure: TreatmentPlanningProcedurePseudoModel, isSave: boolean = true) {
    //console.log('calculateProcedureCosts save:', isSave);
    const patientInsurance = this.insuranceModels[0];
    procedure.PriceDueByPatient = 0;
    procedure.Deductible = procedure.isDeductibleEdited ? procedure.Deductible : this.getDeductibleAmount(procedure);

    // console.log('calculateProcedureCosts procedure.PriceAdjusted:', procedure.PriceAdjusted);
    // console.log('calculateProcedureCosts procedure.Deductible:', procedure.Deductible);
    // console.log('calculateProcedureCosts this.cfgTDOClient.ARisEstimating:', this.cfgTDOClient.ARisEstimating);
    if (procedure.PriceAdjusted) {

      if (this.cfgTDOClient.ARisEstimating)
        this.calculateProcedureFeeAREstimation(procedure, patientInsurance);
      else
        this.calculateProcedureFeeNonAREstimation(procedure, patientInsurance);

      this.reduceDeductibleAmount(procedure, procedure.Deductible);
      if (isSave) {
        this.savePlanProcedure(procedure);
      }
    }
  }

  private calculateProcedureFeeNonAREstimation(procedure: TreatmentPlanningProcedurePseudoModel, patientInsurance: PatientInsuranceDataModel) {
    let patientDuePrice = 0;
    let priceRemainingAfterDeductible = procedure.PriceAdjusted;
    const deductibleApplicable = this.isDeductibleApplicable(procedure, patientInsurance);

    if (procedure.isDeductibleEdited) {
      priceRemainingAfterDeductible = procedure.PriceAdjusted - procedure.Deductible;
    }
    else if (deductibleApplicable && this.ARNonEstimatingDeductibleLeft > 0) {
      if (procedure.PriceAdjusted <= this.ARNonEstimatingDeductibleLeft) {
        // The procedure fee is less than the deductible
        patientDuePrice = procedure.PriceAdjusted;
        procedure.Deductible = procedure.PriceAdjusted;
        priceRemainingAfterDeductible = 0;
        procedure.PriceTotalDueByInsurance = 0;
      }
      else {
        priceRemainingAfterDeductible = procedure.PriceAdjusted - this.ARNonEstimatingDeductibleLeft;
        patientDuePrice = procedure.PriceAdjusted - this.ARNonEstimatingDeductibleLeft; // Add remainder from priceRemainingAfterDeductible after coverages removed
        procedure.Deductible = this.ARNonEstimatingDeductibleLeft;
      }
    }
    else
      procedure.Deductible = 0;


    if (procedure.isInsuranceEdited) {
      patientDuePrice = procedure.Deductible + priceRemainingAfterDeductible - procedure.PriceTotalDueByInsurance;
      procedure.PriceDueByPatient = Math.round(patientDuePrice * 100) / 100;
      this.insuranceBenefitsLeft -= procedure.PriceTotalDueByInsurance;
    }
    else if (this.insuranceBenefitsLeft > 0) {
      // COVERAGES INTO PLAY ///////////////////////////////////////////////////////////////////////////////////////

      const coverageDecimal = procedure.CoveragePCT / 100;
      let coverageRounded = Math.round((priceRemainingAfterDeductible * coverageDecimal) * 100) / 100;
      if (coverageRounded >= this.insuranceBenefitsLeft) {
        coverageRounded = this.insuranceBenefitsLeft;
      }

      procedure.PriceTotalDueByInsurance = coverageRounded;
      patientDuePrice = procedure.Deductible + priceRemainingAfterDeductible - coverageRounded;
      procedure.PriceDueByPatient = Math.round(patientDuePrice * 100) / 100;
      this.insuranceBenefitsLeft -= coverageRounded;
      // END COVERAGES /////////////////////////////////////////////////////////////////////////////////////////////
    } else {
      // No benefits for the year remain
      procedure.PriceDueByPatient = procedure.PriceAdjusted;
      procedure.PriceTotalDueByInsurance = 0;
    }

  }

  isDeductibleApplicable(procedure: TreatmentPlanningProcedurePseudoModel, patientInsurance: PatientInsuranceDataModel) {
    switch (procedure.enumFeeItemCategoryId) {
      case FeeItemCategoryIdEnum.Preventative:
        return patientInsurance.isBenefitsPreventative;
      case FeeItemCategoryIdEnum.Basic:
        return patientInsurance.isBenefitsStandard;
      case FeeItemCategoryIdEnum.Other:
        return patientInsurance.isBenefitsOther;
      default:
        return false;
    }
  }


  private calculateProcedureFeeAREstimation(procedure: TreatmentPlanningProcedurePseudoModel, patientInsurance: PatientInsuranceDataModel) {
    //console.log('calculateProcedureFeeAREstimation:');
    let patientDuePrice = 0;
    let priceRemainingAfterDeductible = 0;
    const procedureFee = procedure.PriceAdjusted;
    if (procedureFee <= procedure.Deductible) {
      // The procedure fee is less than the deductible
      procedure.PriceDueByPatient = procedureFee;
      procedure.Deductible = procedureFee;
      procedure.PriceTotalDueByInsurance = 0;
    }
    else {
      priceRemainingAfterDeductible = procedureFee - procedure.Deductible;
      procedure.PriceDueByPatient = procedure.Deductible; // Add remainder from priceRemainingAfterDeductible after coverages removed
      //console.log('calculateProcedureFeeAREstimation this.insuranceBenefitsLeft: ', this.insuranceBenefitsLeft);

      if (procedure.isInsuranceEdited) { 
        // console.log('calculateProcedureFeeAREstimation insurance edited');
        procedure.CoverageAmount = procedure.PriceTotalDueByInsurance;
        procedure.PriceDueByPatient += priceRemainingAfterDeductible - procedure.PriceTotalDueByInsurance;
      }
      else if (this.insuranceBenefitsLeft > 0) {
        // COVERAGES INTO PLAY ///////////////////////////////////////////////////////////////////////////////////////
        //console.log('calculateProcedureFeeAREstimation procedure.isInsuranceEdited: ', procedure.isInsuranceEdited);

        //console.log('calculateProcedureFeeAREstimation NOT insurance edited');

        if (procedure.enumFeeCoverageCalcTypeId === FeeCoverageCalcTypeEnum.Percent) {
          const coverageDecimal = procedure.CoveragePCT / 100;
          let coverageRounded = Math.round((priceRemainingAfterDeductible * coverageDecimal) * 100) / 100;

          if (coverageRounded > this.insuranceBenefitsLeft) {
            coverageRounded = this.insuranceBenefitsLeft;
          }

          procedure.PriceTotalDueByInsurance = coverageRounded;
          patientDuePrice += priceRemainingAfterDeductible - coverageRounded + procedure.Deductible;
          procedure.PriceDueByPatient = Math.round(patientDuePrice * 100) / 100;
        }
        else if (procedure.CoverageAmount > priceRemainingAfterDeductible) {
          procedure.PriceTotalDueByInsurance = priceRemainingAfterDeductible;
          procedure.PriceDueByPatient = 0;
        } else {
          procedure.PriceDueByPatient += procedureFee - procedure.PriceTotalDueByInsurance;
        }


        //console.log('calculateProcedureFeeAREstimation insuranceBenefitsLeft: ', this.insuranceBenefitsLeft);
        // END COVERAGES /////////////////////////////////////////////////////////////////////////////////////////////
      } 
      else {
        // No benefits for the year remain
        procedure.PriceDueByPatient = procedureFee;
        procedure.PriceTotalDueByInsurance = 0;
      }
      this.insuranceBenefitsLeft = ConversionUtilities.roundDecimal(this.insuranceBenefitsLeft - procedure.PriceTotalDueByInsurance);

      //console.log('calculateProcedureFeeAREstimation procedure.PriceTotalDueByInsurance: ', procedure.PriceTotalDueByInsurance);
      //console.log('calculateProcedureFeeAREstimation procedure.PriceDueByPatient: ', procedure.PriceDueByPatient);
    }
  }

  private getDeductibleAmount(procedure: TreatmentPlanningProcedurePseudoModel) {
    let deductible = 0;
    if (!this.cfgTDOClient.ARisEstimating) {
      deductible = this.ARNonEstimatingDeductibleLeft;// patientInsurance.BenefitsDeductibleLeft;
    }
    else if (procedure.enumFeeItemCategoryId === FeeItemCategoryIdEnum.Preventative) {
      deductible = this.AREstimateDeductibleLeftPreventative;// patientInsurance.BenefitsDeductableLeftPreventitive;
    } else if (procedure.enumFeeItemCategoryId === FeeItemCategoryIdEnum.Basic) {
      deductible = this.AREstimateDeductibleLeftStandard;// patientInsurance.BenefitsDeductableLeftStandard;
    } else if (procedure.enumFeeItemCategoryId === FeeItemCategoryIdEnum.Other) {
      deductible = this.AREstimateDeductibleLeftOther;// patientInsurance.BenefitsDeductableLeftOther;
    }
    return deductible;
  }

  private reduceDeductibleAmount(procedure: TreatmentPlanningProcedurePseudoModel, amount: number) {
    if (!this.cfgTDOClient.ARisEstimating) {
      this.ARNonEstimatingDeductibleLeft -= amount;
    }
    else if (procedure.enumFeeItemCategoryId === FeeItemCategoryIdEnum.Preventative) {
      this.AREstimateDeductibleLeftPreventative -= amount;
    } else if (procedure.enumFeeItemCategoryId === FeeItemCategoryIdEnum.Basic) {
      this.AREstimateDeductibleLeftStandard -= amount;
    } else {
      this.AREstimateDeductibleLeftOther -= amount;
    }
    // if (this.AREstimateDeductibleLeftPreventative < 0)
    //   this.AREstimateDeductibleLeftPreventative = 0;
    // if (this.AREstimateDeductibleLeftStandard < 0)
    //   this.AREstimateDeductibleLeftStandard = 0;
    // if (this.AREstimateDeductibleLeftOther < 0)
    //   this.AREstimateDeductibleLeftOther = 0;
    // if (this.ARNonEstimatingDeductibleLeft < 0)
    //   this.ARNonEstimatingDeductibleLeft = 0;
  }


  private computeBenefitsLeft(plan: TreatmentPlanningDataModel): number {
    const benefitsLeft = this.insuranceModels[0]?.BenefitsLeft ?? 0;
    const covered = plan.Procedures.reduce(
      (sum, p) => ConversionUtilities.roundDecimal(sum + (p.PriceTotalDueByInsurance ?? 0)),
      0
    );
    return ConversionUtilities.roundDecimal(benefitsLeft - covered);
  }

  calculateCurrentTreatmentPlanCost(isSave: boolean = true) {
    console.log('calculateCurrentTreatmentPlanCost: isSave:', isSave);
    if (!this.selectedTreatmentPlan.isApproved) {
      this.ARNonEstimatingDeductibleLeft = this.insuranceModels[0].BenefitsDeductibleLeft??0;
      this.AREstimateDeductibleLeftOther = this.insuranceModels[0].BenefitsDeductableLeftOther??0;
      this.AREstimateDeductibleLeftPreventative = this.insuranceModels[0].BenefitsDeductableLeftPreventitive??0;
      this.AREstimateDeductibleLeftStandard = this.insuranceModels[0].BenefitsDeductableLeftStandard??0;
      this.insuranceBenefitsLeft = this.insuranceModels[0].BenefitsLeft??0;

      this.selectedTreatmentPlan.Procedures.forEach((planProcedure: any) => {
        this.calculateProcedureCosts(planProcedure, false);
      });

      if (isSave) {
        this.saveSelectedPlanProcedures();
      }
    }
  }


  onCodeFieldFocus(event: FocusEvent, procedure: TreatmentPlanningProcedurePseudoModel) {
    this.selectedCodeInput = event.target as HTMLInputElement;
    if (!procedure.ToothID || procedure.ToothID === Constants.emptyGuid) {
      this.uiService.displayMessage('Warning', 'Please select a tooth to get the correct fees.');
      this.selectedCodeInput.blur();
    }
  }

  async handleCodeValueChange(e: string, procedure: TreatmentPlanningProcedurePseudoModel, trigger?: MatAutocompleteTrigger) {
    const code = (e || '').trim();
    if (code.length < 1) {
      procedure.Code = '';
      procedure.Description = '';
      procedure.Fee = 0;
      procedure.Price = 0;
      procedure.PriceAdjusted = 0;
      procedure.PriceTotalDueByInsurance = 0;
      procedure.PriceDueByPatient = 0;
      procedure.CoverageAmount = 0;
      procedure.Deductible = null;
      procedure.ProcedureName = '';
      this.codesList = [];
      if (trigger) {
        trigger.closePanel();
      }
      return;
    }

    this.getCodeFeeData(code, procedure.ToothID, trigger);
  }

  async getCodeFeeData(code: string, toothID: string, trigger?: MatAutocompleteTrigger) {
    this.isLoading = true;
    if (this.codeSearchSubscription) {
      this.codeSearchSubscription.unsubscribe();
      this.codeSearchSubscription = false;
    }
    if (this.caseWorkItemEventDoc === null || this.caseWorkItemEventDoc === undefined) {
      const response = await this.treatmentPlanningService.getSelectedDoctorByCaseWorkItemFormID(this.caseWorkItemFormsId).toPromise();
      if (response === null || response?.ProviderDoctorId === null) {
        this.uiService.displayMessage("Warning", "No doctor was selected from the case view.");
        this.isLoading = false;
        return;
      }
      // Manually map the ProviderDoctorId from response to the local caseWorkItemEventDoc.ProviderDoctorID
      this.caseWorkItemEventDoc = {
        ...response,
        ProviderDoctorID: response.ProviderDoctorId  // Map ProviderDoctorId to ProviderDoctorID
      };
    }

    this.currentDoctorId = this.caseWorkItemEventDoc.ProviderDoctorID;
    if (!this.currentDoctorId || this.currentDoctorId === Constants.emptyGuid) {
      this.uiService.displayMessage('Error', 'No doctor was selected from the case view.');
      this.isLoading = false;
      return;
    }
    this.searchCode = code;
    this.codeSearchSubscription = this.treatmentPlanningService.getCaseProceduresByText(this.currentDoctorId, this.globals.currentPatientId, toothID, code).subscribe((data) => {
      this.codesList = data;
      this.isLoading = false;
      // Ensure code suggestions render/open immediately while typing.
      if (trigger) {
        trigger.openPanel();
      }
      this.safeDetectChanges();
    }, err => {
      this.codeSearchSubscription = false;
      console.log(err);
      this.uiService.displayMessage('Error', `Error obtaining codes: ${err.error.ExceptionMessage}`);
      this.isLoading = false;
      if (trigger) {
        trigger.closePanel();
      }
    });
  }

  onCodeAutoComplete(event, option: FeeStructureDataModel, procedure: TreatmentPlanningProcedurePseudoModel) {
    option.DoctorId = this.currentDoctorId;
    this.treatmentPlanningService.getFeeData(option).subscribe((res) => {
      procedure.Code = res.Code;
      procedure.Description = res.CodeDescription; // res.ProcedureDescription;
      procedure.ProcedureDoctorId = option.DoctorId;
      procedure.ProviderDoctorId = option.DoctorId;
      procedure.feeModel = res;
      procedure.CoverageAmount = res.CoverageAmount;
      procedure.CoveragePCT = res.CoveragePCT;
      procedure.Fee = res.OriginalDoctorsFee;
      procedure.Price = res.OriginalDoctorsFee;
      procedure.PriceAdjusted = res.OriginalDoctorsFee;
      procedure.DFormId = res.DFormId;
      procedure.CaseProcedureId = res.CaseProcedureId;
      procedure.enumFeeCoverageCalcTypeId = res.enumFeeCoverageCalcTypeId;
      procedure.enumFeeItemCategoryId = res.enumFeeItemCategoryId;
      procedure.ProcedureName = res.ProcedureName;

      const isPct = res.enumFeeCoverageCalcTypeId === FeeCoverageCalcTypeEnum.Percent;
      if (isPct) {
        procedure.insuranceEstimateTooltip = `Coverage: ${res.CoveragePCT}%`;
      } else {
        procedure.insuranceEstimateTooltip = `Coverage: $${res.CoverageAmount}`;
      }
      console.log('onCodeAutoComplete: call calculateCurrentTreatmentPlanCost: ');
      this.calculateCurrentTreatmentPlanCost();
      this.safeDetectChanges();
    });
  }

  onClosedCodeSearchEvent() {
    this.codesList = null;
  }
  onSelectToothClick(procedure: TreatmentPlanningProcedurePseudoModel = null) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.panelClass = 'dialog';
    if (procedure !== null) {
      dialogConfig.data = new ToothPickerConfigModel();
      dialogConfig.data.isMultiSelect = false;
    }
    const dialogRef = this.dialog.open(ToothPickerComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (!result) {
        return;
      }

      const models: ToothUiManagerModel[] = result;
      procedure.ToothID = models[0].toothModel.ToothId;
      procedure.toothModel = models[0].toothModel;
      // Should the procedure be saved / updated at this point?
      this.saveSelectedPlanProcedures();
    }, err => {
    });
  }

  onOpenProcedureForm(procedure: TreatmentPlanningProcedurePseudoModel) {
    this.isLoading = true;
    this.treatmentPlanningService.getFormData(procedure.TreatmentPlanningProcedureID).subscribe((data) => {
      this.isLoading = false;
      data.procedure = procedure;
      const dialogConfig = new MatDialogConfig();
      dialogConfig.data = data;
      const dialogRef = this.dialog.open(FormsDialogComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(result => {
        if (result === undefined) {
          return;
        }
      }, err => {
      });
    });
  }

  onPriceAdjustment(procedure: TreatmentPlanningProcedurePseudoModel, level: number) {
    // get adjustment amount
    const feeDiscount = this.feeDiscounts.find(a =>
      a.DiscountName === 'Level' + level && a.ProviderDoctorId === this.currentDoctorId);

    // modify procedure.PriceAdjusted
    if (feeDiscount) {
      if (feeDiscount.enumFeeDiscountCalcTypeId === EnumFeeDiscountCalcTypeEnum.Percent) {
        procedure.PriceAdjusted = Math.round((Number(procedure.PriceAdjusted) + ((feeDiscount.DiscountPCT / 100) * Number(procedure.PriceAdjusted))) * 100) / 100;
        procedure.Price = procedure.PriceAdjusted;

      }
      else if (feeDiscount.enumFeeDiscountCalcTypeId === EnumFeeDiscountCalcTypeEnum.Money) {
        procedure.PriceAdjusted = procedure.PriceAdjusted + feeDiscount.DiscountAmount;
        procedure.Price = procedure.PriceAdjusted;
      }

      this.timeoutInstanceId = (Math.random() * 10000).toString();
      const timeoutInstanceLocal = this.timeoutInstanceId;

      setTimeout(() => {
        if (timeoutInstanceLocal === this.timeoutInstanceId) {
          this.calculateCurrentTreatmentPlanCost();
        }
      }, 1000);
    }

  }

  onCreatePlanClick() {
    this.createNewPlanFromToothPicker();
  }

  /**
   * A treatment plan and an option are both treatment plans.  Options are distinctive in the fact that they have a parentTreatmentPlanId
   * which ties them to the overall planning.
   * @param parentTreatmentPlanId if set, a new option is created, otherwise an entirely new planning program is created.
   */
  createNewPlanFromToothPicker(parentTreatmentPlanId: string = null) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.panelClass = 'dialog';

    const dialogRef = this.dialog.open(ToothPickerComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result === undefined) {
        return;
      }
      const models: ToothUiManagerModel[] = result;
      if (models.length > 0) {
        this.isLoading = true;
        this.treatmentPlanningService.createTreatmentPlan(this.globals.currentPatientId, parentTreatmentPlanId, false).subscribe((dataPlans) => {
          const toothIdArr = new Array<string>();
          for (const model of models) {
            toothIdArr.push(model.toothModel.ToothId);
          }

          const parentPlan = dataPlans.find(p => p.ParentTreatmentPlanningID === null);
          const dataPlan = dataPlans.find(p => p.ParentTreatmentPlanningID !== null);

          this.treatmentPlanningService.createTreatmentPlanProcedures(dataPlan.TreatmentPlanningID, toothIdArr).subscribe((procedures) => {
            for (const procedure of procedures) {
              dataPlan.Procedures.push(procedure);
            }

            if (parentPlan) {
              this.listOfParentTreatmentPlans.unshift(parentPlan);
              this.setParentTreatmentPlan(parentPlan);
            } else {
              this.addTab(dataPlan);
              this.currentTreatmentPlans.push(dataPlan);
              this.selectedTreatmentPlan = dataPlan;
              this.selectedTreatmentPlanReadOnly = this.selectedTreatmentPlan.isApproved;
              this.tabPanelTreatmentPlanSelectedIndex = this.treatmentTabs.length;
            }
            this.resizeSignature();
            this.setupPlanTeeth();
            this.isLoading = false;
          });
        }, err => {
          console.log(err);
          this.isLoading = false;
          this.uiService.displayMessage('Error', 'Something went wrong creating the treatment plan.');
        });
      }
    });
  }

  onDeletePlanClick() {
    this.dialogService.openConfirmDialog(`Are you sure you want to delete: <b>${this.selectedParentTreatmentPlan.Description}</b> and all options associated with it?`).subscribe((isConfirmed) => {
      if (isConfirmed) {
        this.deleteTreatmentPlan(this.selectedParentTreatmentPlan);
      }
    });
  }

  deleteTreatmentPlan(planToDelete: TreatmentPlanningDataModel) {
    this.isLoading = true;

    this.treatmentPlanningService.deleteTreatmentPlan(planToDelete.TreatmentPlanningID).subscribe(() => {
      let idx = this.currentTreatmentPlans.findIndex(p => p === planToDelete);
      this.currentTreatmentPlans.splice(idx, 1);

      if (planToDelete.ParentTreatmentPlanningID === null) {
        // If is the parent so removed it from the procedures dropdown too
        idx = this.listOfParentTreatmentPlans.findIndex(p => p.TreatmentPlanningID === planToDelete.TreatmentPlanningID);
        if (idx > -1) {
          this.listOfParentTreatmentPlans.splice(idx, 1);
          this.listOfParentTreatmentPlansSelectedIndex = 0;
          if (this.listOfParentTreatmentPlans.length > 0) {
            this.selectedParentTreatmentPlan = this.listOfParentTreatmentPlans[this.listOfParentTreatmentPlansSelectedIndex];
            this.setParentTreatmentPlan(this.selectedParentTreatmentPlan);
          } else {
            this.selectedParentTreatmentPlan = null;
            this.treatmentTabs = new Array<TreatmentTabModel>();
            this.selectedTreatmentPlan = null;
            this.selectedTreatmentPlanReadOnly = false;
          }
        }
      }
      this.isLoading = false;
    });
  }

  onCreateOptionClick() {
    this.createNewPlanFromToothPicker(this.parentTreatmentPlanId);
  }

  onCreateOptionCopyClick() {
    const parentTreatmentPlanId = this.parentTreatmentPlanId;
    this.isLoading = true;
    const proceduresToCopy = this.selectedTreatmentPlan.Procedures.filter(p => p.isSelected);

    // Create new plan
    this.treatmentPlanningService.createTreatmentPlan(this.globals.currentPatientId, parentTreatmentPlanId, (proceduresToCopy == null || proceduresToCopy.length === 0)).subscribe((newPlans) => {
      this.deselectAllSelectedProcedures();
      const newPlan = newPlans[0];
      this.currentTreatmentPlans.push(newPlan);
      this.addTab(newPlan);
      this.selectedTreatmentPlan = newPlan;
      this.selectedTreatmentPlanReadOnly = this.selectedTreatmentPlan.isApproved;
      this.tabPanelTreatmentPlanSelectedIndex = this.treatmentTabs.length;

      if (proceduresToCopy.length > 0) {
        this.treatmentPlanningService.copyProceduresToTreatmentPlan(this.selectedTreatmentPlan.TreatmentPlanningID, proceduresToCopy).subscribe((procedures) => {
          this.selectedTreatmentPlan.Procedures = procedures;
          this.setupPlanTeeth();
          this.isLoading = false;
        });
      } else {
        this.isLoading = false;
      }
    });
  }

  onCreateOptionMoveClick() {
    const parentTreatmentPlanId = this.parentTreatmentPlanId;
    this.isLoading = true;
    const proceduresToMove = this.selectedTreatmentPlan.Procedures.filter(p => p.isSelected);

    // Create new plan
    this.treatmentPlanningService.createTreatmentPlan(this.globals.currentPatientId, parentTreatmentPlanId, (proceduresToMove == null || proceduresToMove.length === 0)).subscribe((newPlans) => {
      this.deselectAllSelectedProcedures();
      const newPlan = newPlans[0];
      this.currentTreatmentPlans.push(newPlan);
      this.addTab(newPlan);
      const lastTreatmentPlan = this.selectedTreatmentPlan;
      this.selectedTreatmentPlan = newPlan;
      this.selectedTreatmentPlanReadOnly = this.selectedTreatmentPlan.isApproved;
      this.tabPanelTreatmentPlanSelectedIndex = this.treatmentTabs.length;


      if (proceduresToMove.length > 0) {
        this.treatmentPlanningService.moveProceduresToTreatmentPlan(this.selectedTreatmentPlan.TreatmentPlanningID, proceduresToMove).subscribe((procedures) => {
          // Remove moved procedures from old plan procedures array.
          for (const procedure of proceduresToMove) {
            const idx = lastTreatmentPlan.Procedures.findIndex(p => p === procedure);
            if (idx > -1) {
              lastTreatmentPlan.Procedures.splice(idx, 1);
            }
          }
          this.selectedTreatmentPlan.Procedures = procedures;
          this.setupPlanTeeth();
          this.isLoading = false;
        });
      } else {
        this.isLoading = false;
      }
    });
  }

  getDiscounts() {
    this.arService.getDiscounts(this.globals.LOCID).subscribe(results => {
      this.feeDiscounts = results.filter(x => x.LOCID === Number(this.globals.LOCID));
    })
  }

  getDiscountAmountText(level: number) {
    const feeDiscount = this.feeDiscounts.find(a =>
      a.DiscountName === 'Level' + level && a.ProviderDoctorId === this.currentDoctorId);
    if (feeDiscount) {
      if (feeDiscount.enumFeeDiscountCalcTypeId === EnumFeeDiscountCalcTypeEnum.Percent) {
        return feeDiscount.DiscountPCT + '%';
      }
      else if (feeDiscount.enumFeeDiscountCalcTypeId === EnumFeeDiscountCalcTypeEnum.Money) {
        return '$' + feeDiscount.DiscountAmount;
      }
      else {
        return '0';
      }
    }
    else {
      return '0';
    }
  }


  onCreateProcedure() {
    this.isLoading = true;
    if (this.isAnythingSelected) {

      const teethArray = new Array<string>();
      for (const model of this.selectedProcedures) {
        teethArray.push(model.ToothID);
      }

      this.treatmentPlanningService.createTreatmentPlanProcedures(this.selectedTreatmentPlan.TreatmentPlanningID, teethArray).subscribe((procedures) => {
        this.selectedTreatmentPlan.Procedures = this.selectedTreatmentPlan.Procedures.concat(procedures);
        this.setupPlanTeeth();
        this.deselectAllSelectedProcedures();
        this.isLoading = false;
        this.refreshView();
      });
    } else {
      if (this.selectedTreatmentPlan?.TreatmentPlanningID) {

        let toothId = null;
        if (this.selectedTreatmentPlan.Procedures.length > 0) {
          toothId = this.selectedTreatmentPlan.Procedures[this.selectedTreatmentPlan.Procedures.length - 1].ToothID;
        }
        else
          toothId = this.caseToothId;


        if (toothId === null) {
          this.treatmentPlanningService.createTreatmentPlanProcedure(this.selectedTreatmentPlan.TreatmentPlanningID).subscribe((procedure) => {
            this.selectedTreatmentPlan.Procedures.push(procedure);
            this.isLoading = false;
            this.refreshView();
          });
        }
        else {
          this.treatmentPlanningService.createTreatmentPlanProcedures(this.selectedTreatmentPlan.TreatmentPlanningID, [toothId]).subscribe((procedures) => {
            this.selectedTreatmentPlan.Procedures = this.selectedTreatmentPlan.Procedures.concat(procedures);
            this.setupPlanTeeth();
            this.isLoading = false;
            this.refreshView();
          });
        }
      }
      else {
        this.uiService.displayMessage('Warning', 'Cannot add procedure, Treatement Plan empty');
      }
    }
  }

  onDeleteProcedures() {
    this.dialogService.openConfirmDialog('Are you sure you want to delete the selected procedures?').subscribe((isConfirmed) => {
      if (isConfirmed) {
        this.isLoading = true;
        this.treatmentPlanningService.deleteTreatmentPlanProcedures(this.selectedProcedures).subscribe((res) => {
          for (const proc of this.selectedProcedures) {
            const idx = this.selectedTreatmentPlan.Procedures.findIndex(p => p === proc);
            if (idx > -1) {
              this.selectedTreatmentPlan.Procedures.splice(idx, 1);
            }
          }
          this.deselectAllSelectedProcedures();
          this.isLoading = false;
          this.refreshView();
        });
      }
    });
  }

  onCreateProceduresByTeeth() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.panelClass = 'dialog';
    const dialogRef = this.dialog.open(ToothPickerComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      // resolve(result);
      if (result === undefined) {
        return;
      }
      this.isLoading = true;
      const models: ToothUiManagerModel[] = result;
      const toothIdArr = new Array<string>();
      for (const model of models) {
        toothIdArr.push(model.toothModel.ToothId);
      }

      this.treatmentPlanningService.createTreatmentPlanProcedures(this.selectedTreatmentPlan.TreatmentPlanningID, toothIdArr).subscribe((procedures) => {
        for (const procedure of procedures) {
          this.selectedTreatmentPlan.Procedures.push(procedure);
        }
        this.setupPlanTeeth();
        this.isLoading = false;
        this.refreshView();
      });
    });
  }

  createProcedure(procedure) {
    // see how to create a procedure.
    // don't forget the forms as well
    // addProcedureForExistingCase

    const CaseProcedureId = procedure.CaseProcedureId;
    const PatientCaseId = this.globals.currentPatientCaseId;
    const toothId = procedure.ToothID;
    return this.caseService.addProcedureForExistingCase(PatientCaseId, CaseProcedureId, toothId).toPromise();
  }

  async openReportForSelectedOption(selectedOption: TreatmentPlanningDataModel) {
    const treatmentPlanningPrintParameters = new PrintTreatmentPlanningModel();
    treatmentPlanningPrintParameters.EnterpriseID = localStorage.getItem('TDOEnterpriseId');
    treatmentPlanningPrintParameters.LOCID = this.globals.LOCID;
    treatmentPlanningPrintParameters.PatientID = this.globals.currentPatientId;
    treatmentPlanningPrintParameters.TreatmentPlanningId = selectedOption.TreatmentPlanningID;
    treatmentPlanningPrintParameters.TDOCID = localStorage.getItem('TDOCID');
    try {
      let documentID = await this.printService.printReport(ReportIDEnum.reportID_FrontDesk_TreatmentPlan, treatmentPlanningPrintParameters).toPromise();
      this.printService.executePrint([documentID]);
    } catch (error) {
      this.uiService.displayMessage('Error', 'Error when trying to print Document.');
    }
  }

  determinePreferredCommunication() {
    if (this.patient) {
      let sms = this.patient.dataContact.dataContactComms.filter(p => p.enumCommMethodID === CommMethodEnum.Mobile && ContactCommsDataModel.isAutoSendEligible(p));
      sms = sms.sort((a, b) => {
        const da = new Date(a.xauditModifiedOn).getTime();
        const db = new Date(b.xauditModifiedOn).getTime();
        return db - da;
      });
      if (sms.length > 0) {
        this.preferredSmsComm = sms[0];
        this.sendToPreferredSMS = true;
      }

      let email = this.patient.dataContact.dataContactComms.filter(p => p.enumCommMethodID === CommMethodEnum.Email && ContactCommsDataModel.isAutoSendEligible(p));
      email = email.sort((a, b) => {
        const da = new Date(a.xauditModifiedOn).getTime();
        const db = new Date(b.xauditModifiedOn).getTime();
        return db - da;
      });
      if (email.length > 0) {
        this.preferredEmailComm = email[0];
        this.sendToPreferredEmail = true;
      }
    }
  }

  getFeeAdjusted(procedure: TreatmentPlanningProcedurePseudoModel): string {
    if (procedure.PriceAdjusted !== null && procedure.PriceAdjusted !== 0) {
      return Number(procedure.PriceAdjusted).toFixed(2).toString();
    } else {
      return '0.00';
    }
  }

  getInsuranceEstimate(procedure: TreatmentPlanningProcedurePseudoModel): string {
    if (procedure.PriceTotalDueByInsurance != null && procedure.PriceTotalDueByInsurance !== 0) {
      return Number(procedure.PriceTotalDueByInsurance).toFixed(2).toString();
    } else {
      return '0.00';
    }
  }

  getDeductible(procedure: TreatmentPlanningProcedurePseudoModel): string {
    // Currently deductible isn't being brought across
    if (procedure.Deductible != null) {
      return Number(procedure.Deductible).toFixed(2).toString();
    } else {
      return '0.00';
    }
  }

  getPaymentEstimate(procedure: TreatmentPlanningProcedurePseudoModel): string {
    if (procedure.PriceDueByPatient !== null && procedure.PriceDueByPatient !== 0) {
      return Number(procedure.PriceDueByPatient).toFixed(2).toString();
    } else {
      return '0.00';
    }
  }

  // Input change handlers
  // TODO: SetTimeout of x seconds so we aren't spamming the backend, but rather when we think they are done typing.  I suppose we could save
  // onBlur (focusout), but then there is the chance the browser is closed without the save. (Alt-f4 or crash for example)
  // The basic onChange methods can be consolidated once sure nothing unique needs to be handled for any of them.
  onPhaseChange(procedure: TreatmentPlanningProcedurePseudoModel) {
    this.savePlanProcedure(procedure);
  }


  onAdjustedFeeChange(event, procedure: TreatmentPlanningProcedurePseudoModel) {
    console.log('onAdjustedFeeChange:');
    procedure.PriceAdjusted = ConversionUtilities.roundDecimal(event.target.value as number);
    procedure.isPriceEdited = true;
    this.calculateCurrentTreatmentPlanCost();
    //this.savePlanProcedure(procedure);
  }

  onInsuranceEstimateChange(event, procedure: TreatmentPlanningProcedurePseudoModel) {
    console.log('onInsuranceEstimateChange:');
    procedure.PriceTotalDueByInsurance = ConversionUtilities.roundDecimal(event.target.value as number);
    procedure.isInsuranceEdited = true;
    this.calculateCurrentTreatmentPlanCost();
    //this.savePlanProcedure(procedure);
  }

  onDeductibleChange(event, procedure: TreatmentPlanningProcedurePseudoModel) {
    console.log('onDeductibleChange:');
    procedure.Deductible = ConversionUtilities.roundDecimal(event.target.value as number);
    procedure.isDeductibleEdited = true;
    this.calculateCurrentTreatmentPlanCost();
    //this.savePlanProcedure(procedure);
  }

  saveSelectedPlanProcedures(skipUserInput: boolean = true) {
    if (!skipUserInput && !this.isUserInput)
      return;
    if (!this.selectedTreatmentPlan) {
      return;
    }
    if (!this.selectedTreatmentPlan?.Procedures) {
      return;
    }
    if (this.selectedTreatmentPlan.Procedures.length === 0) {
      return;
    }
    this.treatmentPlanningService.saveTreatmentPlanProcedures(this.selectedTreatmentPlan.Procedures).subscribe((res) => {
      //
    });
  }

  savePlanProcedure(procedure: TreatmentPlanningProcedurePseudoModel) {
    this.treatmentPlanningService.saveTreatmentPlanProcedures([procedure]).subscribe((res) => {
    });
  }
  // Getters
  get patientName() {
    if (this.globals.ThePatient) {
      const currentPatientFullName = this.globals.ThePatient.dataContact.FirstName + ' ' +
        this.globals.ThePatient.dataContact.MidName + ' ' +
        this.globals.ThePatient.dataContact.LastName;
      return currentPatientFullName;
    } else {
      return null;
    }
  }

  get emailList() {
    if (this.patient?.dataContact?.dataContactComms != null) {
      return this.patient.dataContact.dataContactComms.filter(p => p.enumCommMethodID === CommMethodEnum.Email);
    } else {
      return null;
    }
  }

  get mobileList() {
    if (this.patient?.dataContact?.dataContactComms != null) {
      return this.patient.dataContact.dataContactComms.filter(p => p.enumCommMethodID === CommMethodEnum.Mobile);
    } else {
      return null;
    }
  }

  get parentTreatmentPlanId() {
    let parentTreatmentPlanId: string;
    if (this.selectedTreatmentPlan.ParentTreatmentPlanningID !== null) {
      parentTreatmentPlanId = this.selectedTreatmentPlan.ParentTreatmentPlanningID;
    } else {
      parentTreatmentPlanId = this.selectedTreatmentPlan.TreatmentPlanningID;
    }
    return parentTreatmentPlanId;
  }

  onRowSelected(event: TdoTableSelectionEvent) {
    this.changeNotesQuery('dataTreatmentPlanningProcedures', event.row.model.TreatmentPlanningProcedureID);
  }

  createDate() {
    const d = new Date();
    return d.toLocaleDateString();
  }

  // MTE Specific
  saveTooth(tooth: EndoMultiToothExamTeethInExamDataModel) {
    if (this.isUserInput) {
      this.mtiService.saveTooth(tooth).subscribe((res) => { });
    }
  }

  getPulpalDiagValidValue(MTEToothID: string) {
    const mteTooth = this.mtiExam?.dataEndoMutiToothExamTeethinExams.find(p => p.dataEndoMutiToothExamTooth.MTEToothID === MTEToothID);
    if (mteTooth) {
      return mteTooth.dataEndoMutiToothExamTooth?.enumMTEPulpDiagID;
    }
  }

  saveMtePulpalDiag(event: EnumValidValueItemModel, MTEToothID: string) {
    const mteTooth = this.mtiExam?.dataEndoMutiToothExamTeethinExams.find(p => p.dataEndoMutiToothExamTooth.MTEToothID === MTEToothID);
    if (mteTooth) {
      mteTooth.dataEndoMutiToothExamTooth.enumMTEPulpDiagID = event.ValidValueItemId;
      this.saveTooth(mteTooth);
    }
  }

  getPeriapicalDiag(MTEToothID: string) {
    const mteTooth = this.mtiExam?.dataEndoMutiToothExamTeethinExams.find(p => p.dataEndoMutiToothExamTooth.MTEToothID === MTEToothID);
    if (mteTooth) {
      return mteTooth.dataEndoMutiToothExamTooth.enumMTEPerDiagID;
    }
  }

  saveMtePeriapicalDiag(event: EnumValidValueItemModel, MTEToothID: string) {
    const mteTooth = this.mtiExam?.dataEndoMutiToothExamTeethinExams.find(p => p.dataEndoMutiToothExamTooth.MTEToothID === MTEToothID);
    if (mteTooth) {
      mteTooth.dataEndoMutiToothExamTooth.enumMTEPerDiagID = event.ValidValueItemId;
      this.saveTooth(mteTooth);
    }
  }

  getRecommendedTx(MTEToothID: string) {
    const mteTooth = this.mtiExam?.dataEndoMutiToothExamTeethinExams.find(p => p.dataEndoMutiToothExamTooth.MTEToothID === MTEToothID);
    if (mteTooth) {
      return mteTooth.dataEndoMutiToothExamTooth.enumMTERecomendedTxID;
    }
  }

  saveMteRecommendedTx(event: EnumValidValueItemModel, MTEToothID: string) {
    const mteTooth = this.mtiExam?.dataEndoMutiToothExamTeethinExams.find(p => p.dataEndoMutiToothExamTooth.MTEToothID === MTEToothID);
    if (mteTooth) {
      mteTooth.dataEndoMutiToothExamTooth.enumMTERecomendedTxID = event.ValidValueItemId;
      this.saveTooth(mteTooth);
    }
  }

  getEndoPrognosisValidValue(MTEToothID: string) {
    const mteTooth = this.mtiExam?.dataEndoMutiToothExamTeethinExams.find(p => p.dataEndoMutiToothExamTooth.MTEToothID === MTEToothID);
    if (mteTooth) {
      return mteTooth.dataEndoMutiToothExamTooth.enumMTEEndoPrognosisID;
    }
  }

  saveMteEndoPrognosis(event: EnumValidValueItemModel, MTEToothID: string) {
    const mteTooth = this.mtiExam?.dataEndoMutiToothExamTeethinExams.find(p => p.dataEndoMutiToothExamTooth.MTEToothID === MTEToothID);
    if (mteTooth) {
      mteTooth.dataEndoMutiToothExamTooth.enumMTEEndoPrognosisID = event.ValidValueItemId;
      this.saveTooth(mteTooth);
    }
  }

  getPerioPrognosisValidValue(MTEToothID: string) {
    const mteTooth = this.mtiExam?.dataEndoMutiToothExamTeethinExams.find(p => p.dataEndoMutiToothExamTooth.MTEToothID === MTEToothID);
    if (mteTooth) {
      return mteTooth.dataEndoMutiToothExamTooth.enumMTEPerioPrognosisID;
    }
  }

  saveMtePerioPrognosis(event: EnumValidValueItemModel, MTEToothID: string) {
    const mteTooth = this.mtiExam?.dataEndoMutiToothExamTeethinExams.find(p => p.dataEndoMutiToothExamTooth.MTEToothID === MTEToothID);
    if (mteTooth) {
      mteTooth.dataEndoMutiToothExamTooth.enumMTEPerioPrognosisID = event.ValidValueItemId;
      this.saveTooth(mteTooth);
    }
  }

  getRestorativePrognosisValidValue(MTEToothID: string) {
    const mteTooth = this.mtiExam?.dataEndoMutiToothExamTeethinExams.find(p => p.dataEndoMutiToothExamTooth.MTEToothID === MTEToothID);
    if (mteTooth) {
      return mteTooth.dataEndoMutiToothExamTooth.enumMTERestorPrognosisID;
    }
  }

  saveMteRestorativePrognosis(event: EnumValidValueItemModel, MTEToothID: string) {
    const mteTooth = this.mtiExam?.dataEndoMutiToothExamTeethinExams.find(p => p.dataEndoMutiToothExamTooth.MTEToothID === MTEToothID);
    if (mteTooth) {
      mteTooth.dataEndoMutiToothExamTooth.enumMTERestorPrognosisID = event.ValidValueItemId;
      this.saveTooth(mteTooth);
    }
  }

  onRequestedCoronalOther(event: string, model: TreatmentPlanningProcedurePseudoModel) {
    model.RequestedCoronalEndo = event;
    this.saveSelectedPlanProcedures();
  }

  getNumberOfVisitsValidValue(MTEToothID: string) {
    const mteTooth = this.mtiExam?.dataEndoMutiToothExamTeethinExams.find(p => p.dataEndoMutiToothExamTooth.MTEToothID === MTEToothID);
    if (mteTooth) {
      return mteTooth.dataEndoMutiToothExamTooth.enumMTENumberOfVisitsID;
    }
  }

  saveMteNumberOfVisits(event: EnumValidValueItemModel, MTEToothID: string) {
    const mteTooth = this.mtiExam?.dataEndoMutiToothExamTeethinExams.find(p => p.dataEndoMutiToothExamTooth.MTEToothID === MTEToothID);
    if (mteTooth) {
      mteTooth.dataEndoMutiToothExamTooth.enumMTENumberOfVisitsID = (event !== undefined && event !== null) ? event.ValidValueItemId : mteTooth.dataEndoMutiToothExamTooth.enumMTENumberOfVisitsID;
      this.saveTooth(mteTooth);
    }
  }

  onShowFullTestingForTooth(MTEToothID: string) {
    const exam = new EndoMultiToothExamDataModel();
    exam.MTEID = this.mtiExam.MTEID;
    exam.dataEndoMutiToothExamTeethinExams = [this.mtiExam.dataEndoMutiToothExamTeethinExams.find(p => p.MTEToothID === MTEToothID)];
    const config = new MatDialogConfig();
    config.panelClass = 'dialog';
    config.data = { cfgTeeth: this.teeth, exam };
    this.dialog.open(MtiTeethDialogComponent, config);
  }

  onShowIllustrations(MTEToothID: string) {
    this.messagingService.sendComponentMessage(MessagingConstants.OPEN_PREOP_IMAGES, null);
  }

  addCodeNotFound(code: string, toothId: string) {
    const dialogRef = this.dialog.open(CaseAddProcedureComponent, {
      panelClass: 'dialog',
      width: '800px',
      height: '650px',
      maxHeight: '90vh',
      data: {
        searchCode: code,
        isAddCodeNotFound: true,
        isSingleSelection: true,
        patientId: this.globals.currentPatientId,
        doctorId: this.currentDoctorId
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined && result !== false) {
        this.getCodeFeeData(code, toothId);
        this.selectedCodeInput.focus();
        this.selectedCodeInput.value = code;
      }
    }, err => {
      this.uiService.displayMessage("Error", "Error adding procedure code.");
    });
  }

  approvePlan() {
    // Guard against double-click / re-entry: approval is an async round-trip, so a
    // second click before it completes would approve (and create the case) twice.
    if (this.isApproving) {
      return;
    }

    if (this.optionPlanSelected.Procedures.filter(p => p.ProcedureName === '').length > 0) {
      this.uiService.displayMessage("Error", "Treatment option contains empty codes, please fill all fields and remove empty records.");
      return;
    }

    if (this.optionPlanSelected.isApproved) {
      this.uiService.displayMessage("Error", "Treatment option already approved.");
      return;
    }

    const planToApprove = this.optionPlanSelected;
    if (planToApprove.Procedures.every(procedure => {
      procedure.isApproved = true;
      if (!procedure.Code) {
        this.uiService.displayMessage('Error', 'Procedure codes missing in treatment plan');
        return false;
      }
      return true;
    })) {
    
      
      this.isApproving = true;
      this.signatureBase64 = this.signaturePad.toDataURL();
      this.saveOptionProceduresAction(planToApprove).then((result: any) => {
        //this.signatureBase64 = this.signaturePad.toDataURL();
        console.log('saveOptionProceduresAction result: ', result);      
      });
    }
    else
      console.log("TreatmentPlanningComponent unable to approve plan", planToApprove);
  }

  async saveOptionProceduresAction(treatmentPlan: TreatmentPlanningDataModel) {
    const createPatientCaseModel = new CreatePatientCaseModel();
    createPatientCaseModel.ParentCaseId = this.globals.currentPatientCaseId;
    createPatientCaseModel.patientID = this.globals.currentPatientId;
    createPatientCaseModel.TreatmentPlanningID = treatmentPlan.TreatmentPlanningID;
    createPatientCaseModel.LOCID = parseInt(this.globals.LOCID);
    createPatientCaseModel.TreatmentPlanningProcedures = treatmentPlan.Procedures;
    createPatientCaseModel.CaseProcedureId = treatmentPlan.Procedures[0].CaseProcedureId;
    createPatientCaseModel.ReferringDoctorID = (await this.doctorService.getReferringDoctorByCaseId(this.globals.currentPatientCaseId).toPromise())?.DoctorId;

    //this.signatureBase64 = this.signaturePad.toDataURL();
    this.isLoading = true;

    this.treatmentPlanningService.approveTreatmentPlan(createPatientCaseModel).subscribe((response) => {
      this.uiService.displayMessage('Success', 'Plan approved');      
      this.optionPlanSelected.isApproved = true;
      this.treatmentTabs[this.optionPlanSelectedIndex].dataModel.isApproved = true;  
      this.messagingService.sendComponentMessage(MessagingConstants.CASES_REFRESH_SELECT_CASE, { parentCaseId: this.globals.currentPatientCaseId });
    },
      error => {
        this.uiService.displayMessage('Error', error.error.ExceptionMessage);
        this.isLoading = false;
        this.isApproving = false;
        return false;
      },
      () => {
        this.isLoading = false;
        this.isApproving = false;
        return true;
      }
    );
  }
  resizeSignature() {
    if (this.resizeSignatureInterval) {
      clearInterval(this.resizeSignatureInterval);
    }
    this.resizeSignatureInterval = setInterval(() => {
      if (!this.padContainer?.nativeElement || this.padContainer.nativeElement.offsetWidth === 0) {
        return;
      }
      if (!this.signaturePad) {
        return;
      }
      clearInterval(this.resizeSignatureInterval);
      this.resizeSignatureInterval = null;
      const container = this.padContainer.nativeElement;
      this.signatureContainer.nativeElement.width = container.offsetWidth;
      this.signatureContainer.nativeElement.height = container.offsetHeight;
      if (this.signatureURL) {
        this.signaturePad.fromDataURL(this.signatureURL);
      }
    }, 100);
  }

  saveParent() {
    this.treatmentPlanningService.saveTreatmentPlan(this.selectedParentTreatmentPlan).subscribe((res) => {
    });
  }

  saveTabNameDescription(tab: TreatmentTabModel) {
    tab.dataModel.Description = tab.name;
    this.treatmentPlanningService.saveTreatmentPlanDescription(tab.dataModel).subscribe((res) => {
    });

  }

  getDate(d: string | undefined) {
    if (d) {
      return new Date(d).toLocaleDateString();
    }
    return '';
  }

  setUserInput(event: boolean) {
    this.isUserInput = event;
  }

  sendTreatmentToPatient() {
    if (this.optionPlanSelected.Procedures.some(p => !p.ProcedureName || p.ProcedureName === '')) {
      this.uiService.displayMessage("Error", "Treatment option contains empty codes, please fill all fields and remove empty records.");
      return;
    }

    const benefitsLeft = this.computeBenefitsLeft(this.optionPlanSelected);
    if (benefitsLeft < 0) {
      this.uiService.displayMessage("Error", "Insurance benefits left is negative. Please review the treatment option before sending to patient.");
      return;
    }

    this.dialogService.openConfirmDialog(`Do you want to send Treatment Option <br/><b>${this.optionPlanSelected.Description}</b><br/> for patient approval?`).subscribe((confirmSend) => {
      if (confirmSend) {
        this.isLoading = true;
        this.treatmentPlanningService.sendPatientTreatmentPlanApproval(this.optionPlanSelected.TreatmentPlanningID, this.sendToPreferredEmail, this.sendToPreferredSMS).subscribe(resp => {
          if (resp) {
            if (this.optionPlanSelected.TreatmentPlanningID == this.selectedTreatmentPlan.TreatmentPlanningID) {
              this.simpleNote.update();
            }
            this.optionPlanSelected.enumTreatmentPlanStatusID = resp.enumTreatmentPlanStatusID;
            this.optionPlanSelected.isApprovalPending = true;
            if (this.optionPlanSelected.TreatmentPlanningID == this.selectedTreatmentPlan.TreatmentPlanningID) {
              this.selectedTreatmentPlan.isApprovalPending = true;
              this.selectedTreatmentPlanReadOnly = this.selectedTreatmentPlan.isApproved;
            }
            this.treatmentTabs[this.optionPlanSelectedIndex].dataModel.isApprovalPending = true;
            this.isLoading = false;
          }
        },
          error => {
            this.uiService.displayMessage("Error", "Error sending treatment to Patient for approval.");
            this.isLoading = false;
          }
        );
      }
    });
  }

  removeApprovalRequest() {
    this.dialogService.openConfirmDialog(`Do you want to remove Treatment Option <br/><b>${this.optionPlanSelected.Description}</b><br/> from patient approval?`).subscribe((confirmSend) => {
      if (confirmSend) {
        this.isLoading = true;
        this.treatmentPlanningService.removePatientTreatmentPlanApproval(this.optionPlanSelected.TreatmentPlanningID).subscribe(resp => {
          if (resp) {
            if (this.optionPlanSelected.TreatmentPlanningID == this.selectedTreatmentPlan.TreatmentPlanningID) {
              this.simpleNote.update();
            }
            this.optionPlanSelected.enumTreatmentPlanStatusID = resp.enumTreatmentPlanStatusID;
            this.optionPlanSelected.isApprovalPending = false;
            if (this.optionPlanSelected.TreatmentPlanningID == this.selectedTreatmentPlan.TreatmentPlanningID) {
              this.selectedTreatmentPlan.isApprovalPending = false;
              this.selectedTreatmentPlanReadOnly = this.selectedTreatmentPlan.isApproved;
            }
            this.treatmentTabs[this.optionPlanSelectedIndex].dataModel.isApprovalPending = false;
            this.isLoading = false;
          }
        },
          error => {
            this.uiService.displayMessage("Error", "Error sending treatment to Patient for approval.");
            this.isLoading = false;
          }
        );
      }
    });
  }

  isOptionApprovalPending(planOption: TreatmentPlanningDataModel) {
    return planOption.enumTreatmentPlanStatusID.toLowerCase() == '00000a32-1000-0000-0000-000000000002';
  }

  isOptionApproved(planOption: TreatmentPlanningDataModel) {
    return planOption.enumTreatmentPlanStatusID.toLowerCase() == '00000a32-1000-0000-0000-000000000004';
  }
  getTotalPaymentEstimate() {
    return this.selectedTreatmentPlan.Procedures.reduce((n, { PriceDueByPatient }) => n + PriceDueByPatient, 0).toFixed(2);
  }

  getTotalPaymentDeductible() {
    return this.selectedTreatmentPlan.Procedures.reduce((n, { Deductible }) => n + Deductible, 0).toFixed(2);
  }

  getTotalPaymentInsuranceEstimate() {
    return this.selectedTreatmentPlan.Procedures.reduce((n, { PriceTotalDueByInsurance }) => n + PriceTotalDueByInsurance, 0).toFixed(2);
  }

  getTotalPaymentFee() {
    //console.log("Procedures: ", JSON.parse(JSON.stringify(this.selectedTreatmentPlan.Procedures)));
    return this.selectedTreatmentPlan.Procedures.reduce((n, { PriceAdjusted }) => n + PriceAdjusted, 0).toFixed(2);
  }
  onSelectedOption(event) {
    //this.optionPlanSelected = event.value;
    //this.optionPlanSelectedIndex = this.currentTreatmentPlans.indexOf(event.value);
    //this.getSignature();
    console.log('onSelectedOption: call setOptionPlanSelected: ');
    this.setOptionPlanSelected(event.value);  
  }

  setOptionPlanSelected(plan: TreatmentPlanningDataModel) {
    this.selectedTreatmentPlanReadOnly = this.selectedTreatmentPlan.isApproved;
    if (this.optionPlanSelected != plan) {
      this.optionPlanSelected = plan;
      this.optionPlanSelectedIndex = this.currentTreatmentPlans.indexOf(plan);
      this.getSignature();
      this.changeNotesQuery();
      this.calculateCurrentTreatmentPlanCost();
    }
  }

  onRecalculateAmounts() {
    this.selectedTreatmentPlan.Procedures.forEach((planProcedure: any) => {
      planProcedure.isPriceEdited = false;
      planProcedure.isInsuranceEdited = false;
      planProcedure.isDeductibleEdited = false;
    });

    console.log('onRecalculateAmounts: call calculateCurrentTreatmentPlanCost: ');
    this.calculateCurrentTreatmentPlanCost();
  }

  clearSignature() {
    this.initSignaturePad();
  }
  signName() {
    this.signatureDrawn = true;
    console.log('signName: this.currentPatientName: ', this.patientName);
    console.log('signName: this.signaturePad: ', this.signaturePad);
    console.log('signName: this.signatureContainer.nativeElement: ', this.signatureContainer.nativeElement);
    this.signaturePad.clear();
    const canvas = this.signatureContainer.nativeElement;
    console.log('canvas.height', canvas.height);
    console.log('canvas.width', canvas.width);
    const context = canvas.getContext('2d');
    if (context) {
    context.font = '36px script, verdana, sans-serif';
      context.textBaseline = "middle";
      context.textAlign = "center";
      context.fillText(this.patientName.toUpperCase(), canvas.width/2, canvas.height/2,canvas.width-20);
    } else {
      console.error('Could not get context for signature pad');
    }
    this.onSignatureDrawComplete();    
  }
  private safeDetectChanges() {
    //console.log('safeDetectChanges');
    const viewRef = this.cdr as any;
    if (!viewRef.destroyed) {
      this.cdr.detectChanges();
    }
  }
}
